import { ErrorInfo } from 'react';

import { TTextLocalized } from '../types';

export enum ErrorEventsEnum {
  DOCUMENT_PROCESSING_FAILED = 'DOCUMENT_PROCESSING_FAILED',
  DOCUMENT_UPLOAD_FAILED = 'DOCUMENT_UPLOAD_FAILED',
  ERROR_CONNECTION_TIMED_OUT = 'ERROR_CONNECTION_TIMED_OUT',
  ERROR_GETTING_ANDROID_SDK_VERSION = 'ERROR_GETTING_ANDROID_SDK_VERSION',
  ERROR_IN__LOCAL_OR_MMKV_STORAGE = '💾 - Error in Persisted Storage',
  ERROR_IN_API_CALL = '🌐 - Error in API call',
  ERROR_IN_APP = '🅰️ - Application Wide Error',
  ERROR_IN_APP_INITIALIZATION = '⭕️ - Error while initializing the application',
  ERROR_IN_ASYNC_STORAGE = '🗄 - Error Image/File Attachment',
  ERROR_IN_ATTACHMENT = '📎 - Error Image/File Attachment',
  ERROR_IN_DOWNLOADING_PDF = '📜 - Error in downloading PDF',
  ERROR_IN_EXTERNAL_LIBRARY = '📚 - Error in Loading Library',
  ERROR_IN_EXTERNAL_MAPS = '📚 - Error in Loading Google Maps',
  ERROR_IN_PAYMENT = '🏦 - Error in Payment Processing',
  ERROR_IN_PDF = '📜 - Error in PDF',
  ERROR_IN_PERMISSION = '🔐 - Error in Accessing Permissions',
  ERROR_IN_PUSH_NOTIFICATIONS = '🔔 - Error in PUSH NOTIFICATIONS',
  ERROR_IN_REQUESTING_STORAGE_PERMISSION = 'ERROR_IN_REQUESTING_STORAGE_PERMISSION',
  ERROR_IN_SCREEN = '🚨 - Error in Screen',
  ERROR_IN_SCREEN_OR_PAGE = '🚩 - Error Caught by the Screen or Page',
  ERROR_IN_VIDEO_PREVIEW = '🎥 - Error in Video Preview',
  ERROR_IN_AUDIO = '🔊 - Error in Audio',
  ERROR_INTERNET_CONNECTION = 'ERROR_INTERNET_CONNECTION',
  ERROR_PAGE_NOT_FOUND = '📵 - Page Not Found',
  INVALID_SESSION_ID = 'INVALID_SESSION_ID',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type TErrorEventsKey = keyof typeof ErrorEventsEnum;

export interface IErrorLogToRemoteUtilOptions {
  error: Error | unknown;
  errorCode: ErrorEventsEnum;
  errorTitle?: string;
  message?: string | TTextLocalized;
  params?: Record<string, string | number>;
}

export interface IErrorLoggerOptions {
  error: Error | unknown;
  errorCode: ErrorEventsEnum;
  errorInfo?: Record<string, unknown> | ErrorInfo;
  errorTitle?: string;
  handleAsCrash?: boolean;
  message?: string;
}
